 import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import ScheduleView from "../../widgets/ScheduleView";
import getCorso from "../../services/getCorso";
import getLezioni from '../../services/getLezioni';
import getChiusura from '../../services/getChiusura';
import getInsegnanti from '../../services/getInsegnanti';
import moment from 'moment';
import Utils from '../../utils/utils';
import { EditorState } from 'draft-js';
import { NineCellLoading } from 'react-loadingg';
import 'moment/locale/en-gb';
import 'moment/locale/it';
import StudentLessonInfoWidget from "../../widgets/studentLessonInfoWidget";
import checkUtente from "../../services/checkUtente";
import AdWidget from "../../widgets/AdWidget";
import translateString from "../../utils/Locales";

let t = translateString;

export default class TeacherSchedule extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.dataSourceCords = 0;
    this.todayRef = React.createRef();

    this.linkClicked = false;

    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    this.titlePage = '';

    this.timePrecision = 15;

    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];
    this.subjectName = '';
    this.eventDays = [];
    this.meetings = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: true,
      addElementVisible: false,
      editorState: EditorState.createEmpty()
    }

    this.grid = 2;

    this.state = {
      newEventParam: {
        visible: false
      },
      editEventParam: {
        visible: false,
        meeting: undefined
      },
      editBreakParam: {
        visible: false,
        break: undefined
      }, 
      needToScroll: true,
    };

  }

  async reload() {
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const scheduleType = cookies.get('scheduleType', { path: '/' });
    const currentCourse = cookies.get('currentCourse', { path: '/' });

    this.corso = await getCorso(username, token, currentCourse);
    this.utente = await checkUtente(username, token, username);
    this.lezioni = await getLezioni(username, token);
    this.chiusura = await getChiusura(username, token);
    this.insegnanti = await getInsegnanti(username, token);
    this.currUtente = this.insegnanti.filter((insegnante) => insegnante.id === this.utente[0].user_id)[0];

    this.lezioni = this.lezioni.filter(l => { 
      var altriCorsi = l.altri_corsi.split(';');
      var altriInsegnanti = l.altri_insegnanti.split(';');
      return (l.id_corso == currentCourse || altriCorsi.indexOf(currentCourse) != -1) && (l.id_insegnante == this.currUtente.id || altriInsegnanti.indexOf(this.currUtente.id+';') != -1);
    });

    this.scheduleType = scheduleType;
    this.scheduleSubject = currentCourse;
    this.savedEnabled = false;

    this.subjectName = this.corso.nome;

    var startDate = this.corso.dateStart;
    var endDate = this.corso.dateEnd;

    startDate = moment(startDate, "yyyy-MM-DD");
    endDate = moment(endDate, "yyyy-MM-DD");

    // Elimina i giorni di chiusura e i week end
    this.courseDays = [];
    var tempDate = startDate;
    while (tempDate <= endDate){
      var chiusura = false;
      this.chiusura.forEach(element => {
        if (element.day == moment(tempDate).format('DD-MM-yyyy'))
          chiusura = true;
      });

      if (chiusura == false)
        this.courseDays.push(moment(tempDate));

      tempDate = tempDate.add(1, 'd');
    }
    
    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    this.setState({ editEventParam: { visible: false, meeting: undefined, isLoading: false } });

    if (cookies.get('scrollToDate', { path: '/' }) !== '' && cookies.get('scrollToDate', { path: '/' }) !== undefined) {
      cookies.set('scrollToDate', '', { path: '/' });
    }

    if (this.state.needToScroll) {
      try {
        this.todayRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch(e) {
        console.error(e);
      }
    }

  }

  onContentStateChange = contentState => {

    this.savedEnabled = true;
    this.setState({ contentState});
  }

  async componentDidMount(){

    this.reload();
  }

  hideEditWindow () {
    this.linkClicked = true;
    this.setState({editEventParam: {visible: false }});
    this.setState({editBreakParam: {visible: false }});
  }

  render () {

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    if (!this.corso) return <div/>;

    const cookies = new Cookies();
    const currentCourse = cookies.get('currentCourse', { path: '/' });

    this.linkClicked = false;

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('lez_per_corso') + ': ' + this.corso.name} />
        { 
          this.courseDays.map((v) => {
            moment.locale(t('language_string'));
            
            var todayDate = '';
            var currDate = moment();
            let dateToScroll = cookies.get('scrollToDate', { path: '/' });
            if (dateToScroll != '' && dateToScroll != undefined) {
              todayDate = moment(dateToScroll).subtract(2, 'days');
            } else {
              todayDate = moment().subtract(2, 'days');
            }

            let date_str = Utils.capitalizeFirstLetter(moment(v).format('dddd LL')) ;
            let date = moment(v).format('yyyy-MM-DD');
            var isToday = false;
            var isCurrent = false;

            if (moment(v).format('dddd LL') == moment(todayDate).format('dddd LL')) {
              isToday = true;
            }

            if (moment(v).format('dddd LL') == moment(currDate).format('dddd LL')) {
              isCurrent = true;
            }

            return (
            <div id={"#"+date} key={Math.random()} style={{minHeight: '155px', marginTop: 20}} ref={ isToday ? this.todayRef : null }>
              <div className={"dayString" + (isCurrent ? " today" : "")}>{date_str}</div>
              <ScheduleView 
                key={Math.random()}
                breaks={this.breaks}
                readonly={true}
                timePrecision={this.timePrecision}
                date={date} 
                parent={this}
                lezioni={this.lezioni}
                type={this.scheduleType}
                subject={currentCourse}
                insegnanti={this.insegnanti}
                onMouseClick={(date, time) => {
                  
                  let clickedDate = moment(date + ' ' + time, 'yyyy-MM-DD HH:mm');
                  var found = false;
                  this.lezioni.forEach((lezione) => {
                      if(!found) {

                          let startDate = moment(lezione.data, 'yyyy-MM-DD HH:mm');
                          let endDate = moment(lezione.data, 'yyyy-MM-DD HH:mm').add(parseInt(lezione.durata), 'minutes');

                          if (startDate <= clickedDate && endDate >= clickedDate) {
                              this.setState({ lezione: lezione, showLessonInfo: true });
                              found = true;
                          }
                      }
                  })
                }}
              />
            </div> )
          })
        }

        { this.state.showLessonInfo && (
            <StudentLessonInfoWidget 
                lezione={this.state.lezione}
                insegnante={true}
                show={this.state.showLessonInfo}
                onClose={() => { this.setState({ showLessonInfo: false }) }}
            />
        )}

        <AdWidget bottomWidget={true} />
        </LoadingOverlay>
      </>
    );
  }

}

